import React from "react"
import Skeleton from "@components/Skeleton/Skeleton"
import { TRANSACTION_HISTORY_WIDGET as TransactionHistoryWidgetConfig } from "@widgets/TransactionHistoryWidget/TransactionHistoryWidget.skeleton"
import { UserCard as UserCardConfig } from "@widgets/UserCard/UserCard.skeleton"

function TransactionHistorySkeleton() {
    return (
        <div className="page-container flex">
            <Skeleton config={UserCardConfig} />
            <Skeleton config={TransactionHistoryWidgetConfig} />
        </div>
    )
}

export default TransactionHistorySkeleton
